/* Nukbeh */
// export const logoPath = '/assets/elite-logo.png';
// export const schoolName = 'أسرة النخبة التعليمية';
// export const isNukbeh = true;
// export const usePrintingContract = false;
// export const studentData = {
// 	clothes: true,
// }
// export const studentDataRequires = {
// 	previousSchool: true,
// }
// export const theme = {
// 	primary: '#822580'
// }

/* Al Awal */
// export const logoPath = '/assets/al-awal-logo.png';
// export const schoolName = 'مؤسسة الأول التعليمية الخاصة';
// export const isNukbeh = false;
// export const usePrintingContract = false;
// export const studentData = {
// 	clothes: true,
// }
// export const studentDataRequires = {
// 	previousSchool: true,
// }
// export const theme = {
// 	primary: '#532c85'
// }

/* Al Geel Alarabi */
// export const logoPath = '/assets/al-geel-alarabi.png';
// export const schoolName = 'مدرسة الجيل العربي';
// export const isNukbeh = false;
// export const usePrintingContract = true;
// export const studentData = {
// 	clothes: true,
// }
// export const studentDataRequires = {
// 	previousSchool: true,
// }
// export const theme = {
// 	primary: '#007038'
// }

/* Al Rowad */
export const logoPath = '/assets/al-rowad.png';
export const schoolName = 'مدرسة الرواد';
export const isNukbeh = false;
export const usePrintingContract = false;
export const studentData = {
	clothes: false,
}
export const studentDataRequires = {
	previousSchool: false,
}
export const theme = {
	primary: '#20409a'
}